import React, { Component } from 'react';
import './iamExReUserCard.css';

class IamExReUserCard extends Component {

  state = {
    expandSectionMain: true
  };

    userAccessLevelMsg = {
      '5': 'unrestrained write access to high level services',
      '4': 'restrained write access to high level services',
      '3': 'unrestrained write access to mid level services',
      '2': 'restrained write access to mid level services',
      '1': 'write access to low level services',
      '0': 'no write access'
    };

    componentDidMount() {

    };

    render() {

      const {user} = this.props;

      const {
        restrictedWriteActions,
        unrestrictedWriteActions,
        restrictedWriteServices,
        unrestrictedWriteServices,
        userAccessLevel,
        midLevelServices,
        highLevelServices
      } = user.UserAccessLevel;

      const lastAccessDays = Math.floor((new Date(Date.now()).getTime() - new Date(user.LastAccess.accessDate).getTime()) / (1000 * 60 * 60 * 24));

      const lastAccessLevel =
            lastAccessDays < 45 ? 0 :
              lastAccessDays < 60 ? 3 : 5;

      const accessKeys = user.AccessKeys.map(accessKey => {
        const accessKeyObj = {
          id: accessKey.AccessKeyId,
          status: accessKey.Status,
          age: Math.floor((new Date(Date.now()).getTime() - new Date(accessKey.CreateDate).getTime()) / (1000 * 60 * 60 * 24))
        };
        accessKeyObj.alertLevel =
                accessKeyObj.age < 45 ? 0 :
                  accessKeyObj.age < 60 ? 3 : 5;
        return accessKeyObj;
      });

      return (
        <div className={'IamExReUserCardPage'}>
          <div className={'IamExReUserCardInfo'}>

            <div className="IamExReUserCardButtonDiv" onClick={() => this.handleExpand('SectionMain')}>
              <h1>{`${user.UserName} - ${user.Account} - ${user.AccountId}`}</h1>
            </div>

            {this.state.expandSectionMain &&
              <React.Fragment>

                <div className="AlertParagraph">
                  <div className={`UserAlertBar UserAlertBar_${lastAccessLevel}`}></div>
                  <h2>Last Access: {lastAccessDays} days ago via {user.LastAccess.method}.</h2>
                </div>

                <div className="AlertParagraph IamExReUserCardButtonDiv" onClick={() => this.handleExpand('SectionWriteAccess')}>
                  <div className={`UserAlertBar UserAlertBar_${userAccessLevel}`}></div>
                  <h2>Write Access Level: {userAccessLevel} - User has {this.userAccessLevelMsg[userAccessLevel]}.</h2>
                </div>

                {
                  this.state.expandSectionWriteAccess &&
                  <React.Fragment>

                    <p>Restricted Write Access: {restrictedWriteActions} Actions - {restrictedWriteServices} Services</p>
                    <p>Unrestricted Write Access: {unrestrictedWriteActions} Actions - {unrestrictedWriteServices} Services</p>

                    <div className="IamExReUserCardButtonDiv Indent1" onClick={() => this.handleExpand('SectionMid')}>
                      <h3>Mid Level Services</h3>
                    </div>

                    {this.state.expandSectionMid && midLevelServices.map(service => {
                      return (
                        <React.Fragment key={service.servicePrefix}>
                          <div className="IamExReUserCardButtonDiv Indent2" onClick={() => this.handleExpand(`Section${service.servicePrefix}`)}>
                            <h4>{`${service.serviceName} [${service.servicePrefix}] - ${service.Unrestricted} unrestricted write action(s) - ${service.Restricted} restricted write action(s)`}</h4>
                          </div>
                          {this.state[`expandSection${service.servicePrefix}`] && service.actions.map(action => {
                            return <p key={action.Action} className="Indent3">{`${action.Action} is ${action.Allow}`}</p>;
                          })}
                        </React.Fragment>
                      );
                    })}

                    <div className="IamExReUserCardButtonDiv Indent1" onClick={() => this.handleExpand('SectionHigh')}>
                      <h3>High Level Services</h3>
                    </div>

                    {this.state.expandSectionHigh && highLevelServices.map(service => {
                      return (
                        <React.Fragment key={service.servicePrefix}>
                          <div className="IamExReUserCardButtonDiv  Indent2" onClick={() => this.handleExpand(`Section${service.servicePrefix}`)}>
                            <h4>{`${service.serviceName} [${service.servicePrefix}] - ${service.Unrestricted} unrestricted write action(s) - ${service.Restricted} restricted write action(s)`}</h4>
                          </div>
                          {this.state[`expandSection${service.servicePrefix}`] && service.actions.map(action => {
                            return <p key={action.Action} className="Indent3">{`${action.Action} is ${action.Allow}`}</p>;
                          })}
                        </React.Fragment>
                      );
                    })}

                  </React.Fragment>
                }

                {user.LoginProfile &&
                  <React.Fragment>

                    <div className="AlertParagraph">
                      <div className={`UserAlertBar UserAlertBar_${user.MFADevices.length > 0 ? 0 : 5}`}></div>
                      <h2>MFA {user.MFADevices.length > 0 ? '' : 'not '}active on level 5 access account.</h2>
                    </div>

                  </React.Fragment>
                }

                {accessKeys.map((accessKey, index) => {
                  return (
                    <React.Fragment key={accessKey.id}>

                      <div className="AlertParagraph IamExReUserCardButtonDiv" onClick={() => this.handleExpand(`SectionAccessKey${index}`)}>
                        <div className={`UserAlertBar UserAlertBar_${accessKey.alertLevel}`}></div>
                        <h2>Access Key {index + 1}: {accessKey.age} days old.</h2>
                      </div>

                      {this.state[`expandSectionAccessKey${index}`] &&
                        <React.Fragment>
                          <p>Access Key ID: {accessKey.id}</p>
                        </React.Fragment>
                      }

                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            }
          </div>
        </div>
      );

    };

    handleExpand = section => {
      this.setState({[`expand${section}`]: !this.state[`expand${section}`]});
    }

};

export default IamExReUserCard;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExReport/iamExReContent/iamExReUserCard/iamExReUserCard.js